// i18next-extract-mark-ns-start index
import * as React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Hero from '../components/landing/Hero';
import EventCarousel from '../components/event/EventCarousel';
import TestimonialsCarousel from '../components/landing/Testimonials';
import 'pure-react-carousel/dist/react-carousel.es.css';
import BlogLatest from '../components/blog/BlogLatest';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { SEO } from '../components/seo';
import seo from '../../seo.json';

const Index = ({ data, location }) => {
  const { t } = useTranslation();
  const events = data.allEventYaml.nodes;
  const testimonials = data.allTestimonialsYaml.nodes;
  const blogs = data.allMdx;

  return (
    <div className="bg-light-grey">
      <Layout>
        <Hero />
        <div className="mx-auto max-w-full md:px-6 lg:px-8 pt-12 pb-8 bg-light-grey">
          <h2 className="text-3xl font-bold text-center">
            {t('Najnovšie udalosti')}
          </h2>
        </div>
        <div className="mx-auto max-w-7xl md:px-6 lg:px-8 py-4 bg-light-grey">
          <EventCarousel slides={events} allButton={true} />
        </div>
        <div className="mx-auto max-w-7xl md:px-6 lg:px-8 py-8 bg-light-grey">
          <h2 className="text-3xl font-bold text-center">
            {t('Najnovšie blogy')}
          </h2>
          <BlogLatest data={blogs} allButton={true} />
        </div>
        <div className="mx-auto  md:px-6 lg:px-8 py-12 bg-white">
          <div className="max-w-7xl mx-auto ">
            <h2 className="text-3xl font-bold text-center py-4">
              {t('Čo povedali naši klienti?')}
            </h2>
            <TestimonialsCarousel slides={testimonials} />
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Index;

export const Head = ({ pageContext }) => {
  const language = pageContext.language || 'sk';
  return (
    <SEO
      title={seo[language]['index.title']}
      description={seo[language]['index.description']}
    />
  );
};

export const pageQuery = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: {
        ns: { in: ["common", "index", "eventCarousel", "Hero"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }

    allEventYaml(
      filter: { language: { eq: $language } }
      sort: { date: DESC }
      limit: 3
    ) {
      nodes {
        project {
          name
          kind
          uri
        }
        text
        date(formatString: "Y/MM")
        gallery {
          image {
            childImageSharp {
              gatsbyImageData
            }
            publicURL
          }
        }
      }
    }
    allTestimonialsYaml(filter: { language: { eq: $language } }) {
      nodes {
        text
        person
        role
        image {
          childImageSharp {
            gatsbyImageData(layout: FIXED)
          }
        }
        logo {
          childImageSharp {
            gatsbyImageData(layout: FIXED)
          }
        }
      }
    }

    allMdx(
      filter: {
        frontmatter: {
          kind: { eq: "blog" }
          language: { eq: $language }
          publish: { eq: true }
        }
      }
      sort: { frontmatter: { date: DESC } }
      limit: 3
    ) {
      nodes {
        frontmatter {
          kind
          language
          title
          uri
          perex
          date(locale: "sk", formatString: "MMMM DD, YYYY")
          author {
            name
            role
            photo {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  }
`;
